export default "__VITE_ASSET__iBR_QVm1__"